/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommandCreatorDto } from './commandCreatorDto';


export interface CommandRequestDto { 
    afterInsertTsInclusive?: string;
    afterReceivedResponseTimeInclusive?: string;
    beforeInsertTsExclusive?: string;
    beforeReceivedResponseTimeExclusive?: string;
    commandStateFilter?: Array<CommandRequestDto.CommandStateFilterEnum>;
    count?: number;
    createdByFilter?: Array<CommandCreatorDto>;
    deviceClassWithOwnIdPoolFilter?: Array<CommandRequestDto.DeviceClassWithOwnIdPoolFilterEnum>;
    deviceIdsFilter?: Array<number>;
    excludeCreatedByFilter?: Array<CommandCreatorDto>;
    includeConfigDataStatus?: boolean;
    includeWildlifeEventCommand?: boolean;
    initialCommandFilter?: boolean;
    orderBy?: string;
    orderDirection?: string;
    originCodeFilter?: Array<CommandRequestDto.OriginCodeFilterEnum>;
    page?: number;
    readoutCommandFilter?: boolean;
}
export namespace CommandRequestDto {
    export const CommandStateFilterEnum = {
        Created: 'CREATED',
        SentToServer: 'SENT_TO_SERVER',
        SentToDevice: 'SENT_TO_DEVICE',
        FailedSendingToServer: 'FAILED_SENDING_TO_SERVER',
        FailedSendingToDevice: 'FAILED_SENDING_TO_DEVICE',
        FailedOnDevice: 'FAILED_ON_DEVICE',
        FailedUnspecified: 'FAILED_UNSPECIFIED',
        Acknowledged: 'ACKNOWLEDGED',
        Canceled: 'CANCELED',
        FailedExpired: 'FAILED_EXPIRED'
    } as const;
    export type CommandStateFilterEnum = typeof CommandStateFilterEnum[keyof typeof CommandStateFilterEnum];
    export const DeviceClassWithOwnIdPoolFilterEnum = {
        Collar: 'COLLAR',
        ExternalSensor: 'EXTERNAL_SENSOR',
        Camera: 'CAMERA',
        Tt4Sensor: 'TT4_SENSOR',
        ConfigurationDevice: 'CONFIGURATION_DEVICE',
        DropOff: 'DROP_OFF',
        TrapTransmitter: 'TRAP_TRANSMITTER',
        DataLogger: 'DATA_LOGGER'
    } as const;
    export type DeviceClassWithOwnIdPoolFilterEnum = typeof DeviceClassWithOwnIdPoolFilterEnum[keyof typeof DeviceClassWithOwnIdPoolFilterEnum];
    export const OriginCodeFilterEnum = {
        Globalstar: 'GLOBALSTAR',
        Iridium: 'IRIDIUM',
        GsmSms: 'GSM_SMS',
        GsmFtp: 'GSM_FTP',
        Terminal: 'TERMINAL',
        Collar: 'COLLAR',
        NbIot: 'NB_IOT',
        IridiumEmail: 'IRIDIUM_EMAIL'
    } as const;
    export type OriginCodeFilterEnum = typeof OriginCodeFilterEnum[keyof typeof OriginCodeFilterEnum];
}


export type CommandStateFilterEnum = typeof CommandRequestDto.CommandStateFilterEnum[keyof typeof CommandRequestDto.CommandStateFilterEnum];
export type DeviceClassWithOwnIdPoolFilterEnum = typeof CommandRequestDto.DeviceClassWithOwnIdPoolFilterEnum[keyof typeof CommandRequestDto.DeviceClassWithOwnIdPoolFilterEnum];
export type OriginCodeFilterEnum = typeof CommandRequestDto.OriginCodeFilterEnum[keyof typeof CommandRequestDto.OriginCodeFilterEnum];
